<div *ngIf="false" class="p-0">
  <div class="row toolbar align-items-center">
    <!-- Menu icon -->
    <div *ngIf="!toolbarDetails.isBack" (click)="openSideNav()" class="menu col align-self-center">
      <span class="material-icons-outlined d-flex"> menu </span>
    </div>

    <div *ngIf="toolbarDetails.isBack" (click)="goBack()" class="menu col align-self-center">
      <span class="material-icons-outlined d-flex"> arrow_back </span>
    </div>

    <!-- Toolbar name -->
    <div class="col toolbarLabel pl-0">
      <div *ngIf="toolbarDetails.title !== 'Change Password'" class="row primayLabel">
        <span (click)="gotoPage('/dashboard/summary')">{{ toolbarDetails.title }}</span>
      </div>

    </div>

    <!-- Filter section -->
    <div
      *ngIf="toolbarDetails.isShowSearch || toolbarDetails.isBar || toolbarDetails.isShowfilter || toolbarDetails.isShowShare ||
      toolbarDetails.isShowCart || toolbarDetails.isShowRP || toolbarDetails.isShowReturnOrder || 
      (toolbarDetails.isTranAdd && isRouteUser) || toolbarDetails.isShowEditOrderButton || toolbarDetails.isAddRtrn || 
      toolbarDetails.isAdd || toolbarDetails.isShowRefresh || toolbarDetails.isShowDownload || toolbarDetails.isDelete || toolbarDetails.isShowList"
      class="pr-3 d-flex justify-content-end">

      <div *ngIf="toolbarDetails.isShowSearch" class="d-flex align-items-center justify-content-end"
        [ngClass]="isSearchActive ? 'search-active' : ''" (click)="ActivateSearch()">
        <span class="material-icons-outlined p-0" style="font-size: 36px">
          search
        </span>
        <div class="search-close-container" *ngIf="isSearchActive">
          <div class="search-close d-flex align-items-center justify-content-center">
            <span class="material-icons-outlined search-close-icon">
              close
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="toolbarDetails.isShowDownload" class="d-flex align-items-center justify-content-end">
        <a data-toggle="dropdown">
          <span class="material-icons-outlined" style="font-size: 36px">
            file_download
          </span>
        </a>
        <div class="dropdown-menu py-0" style="min-width: auto">
          <a style="border-radius: 5px 5px 0 0" class="dropdown-item my-0 px-1" (click)="download.emit(true)">PDF</a>
          <a style="border-radius: 0 0 5px 5px" class="dropdown-item my-0 px-1"
            (click)="downloadExcel.emit(true)">EXCEL</a>
        </div>
      </div>


      <div *ngIf="toolbarDetails.isShowfilter" class="d-flex align-items-center justify-content-end"
        [ngClass]="isFilterActive ? 'search-active' : ''" (click)="filterClick()">
        <span class="material-icons-outlined p-0" style="font-size: 36px">
          filter_list
        </span>
        <div class="search-close-container" *ngIf="isFilterActive">
          <div class="search-close d-flex align-items-center justify-content-center">
            <span class="material-icons-outlined search-close-icon">
              close
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="toolbarDetails.isShowShare" class="d-flex align-items-center justify-content-end"
        [ngClass]="isFilterActive ? 'search-active' : ''" (click)="filterClick()">
        <span class="material-symbols-outlined p-0" style="font-size: 26px">
          share
          </span>
        <div class="search-close-container" *ngIf="isFilterActive">
          <div class="search-close d-flex align-items-center justify-content-center">
            <span class="material-icons-outlined search-close-icon">
              close
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="toolbarDetails.isShowCart" class="row align-items-center justify-content-end"
        (click)="loggedInUserID !== 0? this.router.navigate(['/cart']): this.router.navigate(['/public/login'])">
        <span class="material-icons rightSideIcon"> shopping_cart </span>
        <div class="search-close-container">
          <div *ngIf="CartCount" class="small text-white search-close d-flex align-items-center justify-content-center">
            {{ CartCount }}
          </div>
        </div>
      </div>

      <div *ngIf="toolbarDetails.isShowRP" (click)="rp.emit(true)" class="row align-items-center justify-content-end">
        <span style="padding: 15px">+ RP</span>
      </div>

      <div *ngIf="toolbarDetails.isShowReturnOrder" style="width: 45px" (click)="return.emit(true)"
        class="row align-items-center justify-content-center align-content-center">
        <div class="d-flex">
          <span class="material-icons" style="padding-left: 2px"> undo </span>
        </div>
        <div style="font-size: 10px; width: 100%; text-align: center">
          Return
        </div>
      </div>

      <div *ngIf="toolbarDetails.isTranAdd && isRouteUser" style="width: 45px" (click)="addTran.emit(true)"
        class="row align-items-center justify-content-center align-content-center">
        <div class="d-flex">
          <span class="material-icons" style="padding-left: 2px"> add </span>
        </div>
        <div style="font-size: 10px; width: 100%; text-align: center">Add</div>
      </div>

      <div *ngIf="toolbarDetails.isAdd" style="width: 45px" (click)="Add.emit(true)"
        class="row align-items-center justify-content-center align-content-center">
        <div class="d-flex">
          <span class="material-icons" style="padding-left: 2px"> add </span>
        </div>
        <div style="font-size: 10px; width: 100%; text-align: center">
          {{ toolbarDetails.addMsg ? toolbarDetails.addMsg : "Add" }}
        </div>
      </div>

      <div *ngIf="toolbarDetails.isShowEditOrderButton" style="width: 45px" (click)="Edit.emit(true)"
        class="row align-items-center justify-content-center align-content-center">
        <div class="d-flex">
          <span class="material-icons" style="padding-left: 2px"> edit </span>
        </div>
        <div style="font-size: 10px; width: 100%; text-align: center">Edit</div>
      </div>

      <div *ngIf="toolbarDetails.isShowStockEdit" style="width: 45px" (click)="StockEdit.emit(true)"
        class="row align-items-center justify-content-center align-content-center">
        <div class="d-flex">
          <span class="material-icons" style="padding-left: 2px"> edit </span>
        </div>
        <div style="font-size: 10px; width: 100%; text-align: center">
          Stock
        </div>
      </div>

      <div *ngIf="toolbarDetails.isShowPriceEdit" style="width: 45px" (click)="PriceEdit.emit(true)"
        class="row align-items-center justify-content-center align-content-center">
        <div class="d-flex">
          <span class="material-icons" style="padding-left: 2px"> edit </span>
        </div>
        <div style="font-size: 10px; width: 100%; text-align: center">
          Price
        </div>
      </div>

      <div *ngIf="toolbarDetails.isShowCancelOrder" style="width: 45px" (click)="Cancel.emit(true)"
        class="row align-items-center justify-content-center align-content-center">
        <div class="d-flex">
          <span class="material-icons" style="color: tomato"> cancel </span>
        </div>
        <div style="font-size: 10px">Cancel</div>
      </div>

      <div *ngIf="toolbarDetails.isAddRtrn" (click)="gotoPage('/order-list')" style="width: 45px"
        class="row align-items-center justify-content-center align-content-center">
        <div class="d-flex">
          <span class="material-icons"> add </span>
        </div>
        <div style="font-size: 10px">Return</div>
      </div>

      <div *ngIf="toolbarDetails.isDelete" (click)="delete.emit(true)" style="width: 45px"
        class="row align-items-center justify-content-center align-content-center">
        <div class="d-flex">
          <span class="material-icons"> delete </span>
        </div>
        <div style="font-size: 10px">Delete</div>
      </div>

      <div *ngIf="toolbarDetails.isShowList" (click)="sHowProducts.emit(true)"
        class="row align-items-center justify-content-center align-content-center">
        <span class="material-icons-outlined">shopping_cart</span>
        <div class="search-close-container">
          <div class="small text-white search-close d-flex align-items-center justify-content-center">
            {{ toolbarDetails?.productCount }}
          </div>
        </div>
      </div>

      <div *ngIf="toolbarDetails.isBar" class="mx-2" style="background-color: #d9d9d9; width: 1px"></div>

      <div
        *ngIf="toolbarDetails.isShowRefresh && configService.setAppConfig('admin_mobile_toolbar_showRefreshButton' ,false)"
        class="row align-items-center justify-content-end">
        <span class="material-icons rightSideIcon" (click)="Reload.emit(true)">
          refresh
        </span>
      </div>
    </div>
    <div *ngIf="isSuperAdmin" style="height: 2px; width: 100%; background-color: #0057ff"></div>
  </div>
</div>

<!--|||||||||||| SIDE MENU ||||||||||||-->
<div *ngIf="false" id="mySidenav" class="sidenav">

  <div class="row">
    <div class="row w-100 d-flex py-2 header">
        <div *ngIf="configService.sellerConfiguration?.SellerLogo; else storeIcon" class="shop-logo">
            <img [src]="configService.sellerConfiguration?.SellerLogo" onerror="this.src='/assets/images/ecomshop.png'">
        </div>

        <ng-template #storeIcon>
            <div class="sellerlogo">
                <img src="/assets/images/ecomshop.png" style="margin: 20%;width: 40px;">
            </div>
        </ng-template>
    </div>
</div>

  <div *ngIf="false" class="row no-gutters justify-content-end top-logo-pic">
    <div class="col p-2">
      <div class="rounded" style="width: 100%; height: 100%;">
        <img [src]="adminDetails?.SellerLogo" onerror="this.src='/assets/images/PartsonLogWithName.png'"
          style="object-fit: contain; width: 100%; height: 100%;">
      </div>
    </div>
  </div>


  <div class="row pb-5">
    <div *ngIf="originalUser"
      (click)="configService.setAppConfig('admin_mobile_sideMenu_profile', false) ? gotoPage('/profile/profile') : ''" 
      class="row w-100 pt-3">
      <div class="col-2 userIcon">
        <span class="material-icons-outlined"> person </span>
      </div>
      <div class="col- d-flex align-items-center px-0" style="color: #787878; font-weight: 600; line-height: 15px">
        <span>{{ originalUser?.UserName }}</span>
      </div>
      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_profile', false)"
        class="my-profile-nav ml-auto col-1 d-flex justify-content-center align-items-center">
        <span class="material-icons-outlined"> chevron_right </span>
      </div>
    </div>

    <!--  $$$$$$$$$$$$$$$$$$ FOR ADMIN $$$$$$$$$$$$$$$$$$  -->
    <div class="row">

      <div *ngIf="isThirdParty" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/servicenear/dashboard')"> Servicenear </a>
          </div>
        </div>
        <div class="row hint">Servicenear Dashboard </div>
      </div>

      <div class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/dashboard/summary')"> Dashboard</a>
          </div>
        </div>
        <div class="row hint">Dashboard</div>
      </div>

      <!-- SELLERS DETAIL LIST FOR SUPERADMIN -->
      <div *ngIf="isSuperAdmin" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/sellers')"> Sellers</a>
          </div>
        </div>
        <div class="row hint">View all Sellers</div>
      </div>

<!--SALES MENU SECTION  -->
        <div class="col-12 p-0 menuItemWrap"  data-toggle="collapse" href="#collapseExample"  aria-expanded="false" aria-controls="collapseExample" (click)="toggleCollapse()">
          <div class="row">
            <div class="col p-0 d-flex align-items-center">
              <a>Sales</a>
              <span class="material-icons-outlined ml-2">
                {{ isCollapsed ? 'expand_more' : 'expand_less' }}
              </span>
              <!-- <i class="ml-5 bi" [ngClass]="{'bi-chevron-down': isCollapsed, 'bi-chevron-up': !isCollapsed}"></i> -->
            </div>
          </div>
          <div class="row hint">View Orders & Returns</div>
        </div>
      <div class="collapse" id="collapseExample" (shown.bs.collapse)="isCollapsed = false" (hidden.bs.collapse)="isCollapsed = true">
        <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_allOrders', false)" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/sales/all-orders')">All orders</a>
            </div>
          </div>
          <div class="row hint">View all Orders</div>
        </div>
  
        <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_allReturns', false)" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/sales/all-returns')"> All returns </a>
            </div>
          </div>
          <div class="row hint">
            View all Returns
          </div>
        </div>
      </div>
<!--PRODUCTS MENU SECTION  -->
      <div class="col-12 p-0 menuItemWrap"  data-toggle="collapse" href="#collapseExampletwo"  aria-expanded="false" aria-controls="collapseExampletwo" (click)="toggleCollapse()">
        <div class="row">
          <div class="col p-0 d-flex align-items-center">
            <a>Products</a>
            <span class="material-icons-outlined ml-2">
              {{ isCollapsed ? 'expand_more' : 'expand_less' }}
            </span>
          </div>
        </div>
        <div class="row hint">Products Overview & Management</div>
      </div>
      <div class="collapse" id="collapseExampletwo" (shown.bs.collapse)="isCollapsed = false" (hidden.bs.collapse)="isCollapsed = true">
        <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_addProduct', false)" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoAddProduct();"> Add product</a>
            </div>
          </div>
          <div class="row hint">Add new products</div>
        </div>
  
        <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_productList', false)" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/products/product-list')">Products</a>
            </div>
          </div>
          <div class="row hint">View all products</div>
        </div>
  
        <div [ngClass]="{ 'disabled-link': isThirdParty }" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/products/Highlighted')">Highlighted Products</a>
            </div>
          </div>
          <div class="row hint">Manage highlighted products</div>
        </div>

        <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_categoryList', false) && !isReseller" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/products/categories')">Categories</a>
            </div>
          </div>
          <div class="row hint">View and add categories</div>
        </div>
  
        <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_damagelist', false)" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/products/Damagelist')"> Damage List <span class="beta-tag">Beta</span></a>
            </div>
          </div>
          <div class="row hint">View all Damagelist</div>
        </div>

        <div [ngClass]="{ 'disabled-link': isThirdParty }" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/products/ReviewList')">Review List</a>
            </div>
          </div>
          <div class="row hint">View All Customer Reviews</div>
        </div>

      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_ResellingProductList', false) && !isReseller" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/Reseller/ResellingProducts')">Reselling Products</a>
          </div>
        </div>
        <div class="row hint">View all products added to resell</div>
      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_disabledProductList', false)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/admin/disabled-products')">Disabled products</a>
          </div>
        </div>
        <div class="row hint">View all disabled products</div>
      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_bulkUpdate', false) && !isReseller" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/products/bulk-edit')"> Bulk update</a>
          </div>
        </div>
        <div class="row hint">Update stock & price</div>
      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_pincodes', false)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/admin/pincodes')">Pincodes</a>
          </div>
        </div>
        <div class="row hint">View & add pincodes</div>
      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_pickupLocations', false) && !isReseller" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/admin/pickup-locations')">Pickup locations</a>
          </div>
        </div>
        <div class="row hint">View & add pickup locations</div>
      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_deliverypartners', false) && !isReseller" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/admin/delivery-partners')">Delivery partners</a>
          </div>
        </div>
        <div class="row hint">View & add delivery partners</div>
      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_changeRequestList', false)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/Reseller/ChangeRequestList')">Change request list</a>
          </div>
        </div>
        <div class="row hint">View all product modify requests</div>
      </div>
<!--USERS MENU SECTION  -->
      <div  class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/user/list')"> Users</a>
          </div>
        </div>
        <div class="row hint">View all users</div>
      </div>
<!--CUSTOMER MENU SECTION  -->
      <div class="col-12 p-0 menuItemWrap"  data-toggle="collapse" href="#collapseExamplethree"  aria-expanded="false" aria-controls="collapseExamplethree" (click)="toggleCollapse()">
        <div class="row">
          <div class="col p-0 d-flex align-items-center">
            <a>Customers</a>
            <span class="material-icons-outlined ml-2">
              {{ isCollapsed ? 'expand_more' : 'expand_less' }}
            </span>
          </div>
        </div>
        <div class="row hint">Customer Overview & Management</div>
      </div>
      <div class="collapse" id="collapseExamplethree" (shown.bs.collapse)="isCollapsed = false" (hidden.bs.collapse)="isCollapsed = true">
      <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_usersList', false)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/user/userlist')"> Customers</a>
          </div>
        </div>
        <div class="row hint">View all customers</div>
      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_usersList', false) && isThirdParty" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/user/shoplist')"> Shops</a>
          </div>
        </div>
        <div class="row hint">View all shops</div>
      </div>

      <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_activecartList', false)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/cart/Active-cart')">Active Cart</a>
          </div>
        </div>
        <div class="row hint">View all customers Cart</div>
      </div>

      <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_activecartList', false)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('user/customer-add/user')">Add Customer</a>
          </div>
        </div>
        <div class="row hint">Create new customer</div>
      </div>

      <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_abandonedcart', true)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/cart/Abandoned-cart')">Abandoned Cart</a>
          </div>
        </div>
        <div class="row hint">View all customers Abandoned Cart</div>
      </div>

      <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_wishlist', false)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/admin/wishlist')"> Wishlist</a>
          </div>
        </div>
        <div class="row hint">View all customers Wishlist</div>
      </div>
      </div>

      <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_userFlow', false)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/admin/user-flow')"> Customers flow </a>
          </div>
        </div>
        <div class="row hint">View customers flow</div>
      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_createOffer', false) && !isReseller" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/admin/offer-edit/0')">Create offer</a>
          </div>
        </div>
        <div class="row hint">Created new offers</div>
      </div>

      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_offersList', false) && !isReseller" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/admin/offer-list')">Offer list</a>
          </div>
        </div>
        <div class="row hint">View all created offers</div>
      </div>

      <div [ngClass]="{ 'disabled-link': isThirdParty }" *ngIf="configService.setAppConfig('admin_mobile_sideMenu_topbanners', false)" class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="gotoPage('/admin/top-banners')">Banners</a>
          </div>
        </div>
        <div class="row hint">View and manage top banners</div>
      </div>

      <!-- Reports -->
      <div *ngIf="configService.setAppConfig('admin_mobile_sideMenu_reports', false)" (click)="showReports($event)"
        class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <div class="reports">
              Reports
              <span *ngIf="isShowReportList" class="material-icons-outlined expand" style="font-size: 36px">
                expand_less
              </span>
              <span *ngIf="!isShowReportList" class="material-icons-outlined expand" style="font-size: 36px">
                expand_more
              </span>
            </div>
          </div>
        </div>
        <div class="row hint">View reports</div>
      </div>

      <div *ngIf="isShowReportList" class="reports-dropdown">
        <div *ngIf="configService.setAppConfig('admin_mobile_reports_sales', false)" class="col-12 p-0 dropdownItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/reports/sales')">Sales Report</a>
            </div>
          </div>
          <div class="row hint">View sales report</div>
        </div>

        <div *ngIf="configService.setAppConfig('admin_mobile_reports_profit', false)" class="col-12 p-0 dropdownItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/reports/profit')">Profit Report</a>
            </div>
          </div>
          <div class="row hint">View profit report</div>
        </div>

        <div *ngIf="configService.setAppConfig('admin_mobile_reports_salesProfit', false)" class="col-12 p-0 dropdownItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/reports/sales-profit')">Sales Profit Report</a>
            </div>
          </div>
          <div class="row hint">View sales profit report</div>
        </div>

        <div *ngIf="configService.setAppConfig('admin_mobile_reports_daywiseProfit', false)" class="col-12 p-0 dropdownItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/reports/day-wise')">Day Wise Report</a>
            </div>
          </div>
          <div class="row hint">View day wise profit report</div>
        </div>

        <div *ngIf="configService.setAppConfig('admin_mobile_reports_productwiseProfit', false)" class="col-12 p-0 dropdownItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/reports/product-wise')">Product Wise Report</a>
            </div>
          </div>
          <div class="row hint">View product wise profit report</div>
        </div>

        <div *ngIf="configService.setAppConfig('admin_mobile_reports_deadStock', false)" class="col-12 p-0 dropdownItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/reports/dead-stock')">Dead Stock Report</a>
            </div>
          </div>
          <div class="row hint">View dead stock report</div>
        </div>

        <div *ngIf="configService.setAppConfig('admin_mobile_reports_damage', false)" class="col-12 p-0 pb-3 dropdownItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/reports/damage')">Damage Report</a>
            </div>
          </div>
          <div class="row hint">View damage report</div>
        </div>
      </div>
<!--SETTING MENU SECTION  -->
      <div class="col-12 p-0 menuItemWrap"  data-toggle="collapse" href="#collapseExamplefour"  aria-expanded="false" aria-controls="collapseExamplefour" (click)="toggleCollapse()">
        <div class="row">
          <div class="col p-0 d-flex align-items-center">
            <a>Settings</a>
            <span class="material-icons-outlined ml-2">
              {{ isCollapsed ? 'expand_more' : 'expand_less' }}
            </span>
          </div>
        </div>
        <div class="row hint">Setting Overview & Management</div>
      </div>
      <div class="collapse" id="collapseExamplefour" (shown.bs.collapse)="isCollapsed = false" (hidden.bs.collapse)="isCollapsed = true">
        <div [ngClass]="{ 'disabled-link': isThirdParty }" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/profile/SubscriptionDetails')"> Subscription</a>
            </div>
          </div>
          <div class="row hint">View current plan & limits</div>
        </div>
  
        <div [ngClass]="{ 'disabled-link': isThirdParty }" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/profile/Settings')"> Settings</a>
            </div>
          </div>
          <div class="row hint">Configure your setting here</div>
        </div>
  
        <div [ngClass]="{ 'disabled-link': isThirdParty }" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/profile/Store-settings')">Store Settings</a>
            </div>
          </div>
          <div class="row hint">Configure your store Setting here</div>
        </div>
        
        <div [ngClass]="{ 'disabled-link': isThirdParty }" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/profile/SEOSettings')">SEO Settings</a>
            </div>
          </div>
          <div class="row hint">Configure SEO data here</div>
        </div>
  
        <div [ngClass]="{ 'disabled-link': isThirdParty }" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/profile/WebsiteContent')">Website Content</a>
            </div>
          </div>
          <div class="row hint">Configure Website Content</div>
        </div>

        <div [ngClass]="{ 'disabled-link': isThirdParty }" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/profile/dvcard')">Dvcard Content</a>
            </div>
          </div>
          <div class="row hint">Configure Dvcard Content</div>
        </div>

        <div [ngClass]="{ 'disabled-link': isThirdParty }" class="col-12 p-0 menuItemWrap">
          <div class="row">
            <div class="col p-0">
              <a (click)="gotoPage('/profile/menucard')">Menu Card Settings</a>
            </div>
          </div>
          <div class="row hint">Configure Menu Card Settings</div>
        </div>

      </div>

      <div class="col-12 p-0 menuItemWrap">
        <div class="row">
          <div class="col p-0">
            <a (click)="logOutClicked()">Logout</a>
          </div>
        </div>
        <div class="row hint">Signout your current account.</div>
      </div>

      <div class="col-12 p-0 menuItemWrap">
        <div class="row hint"> Version_{{configService.version}} </div>
      </div>

    </div>
  </div>

<div *ngIf="false" id="myCloseContainer" (click)="closeSideNav()" class="close-container">
    <div class="d-flex justify-content-end p-1">
        <div class="close-container-btn d-flex justify-content-center align-content-center">
            <i class="material-icons d-flex">close</i>
        </div>
    </div>
</div>
